import { ArrowSquareOut, ClockCounterClockwise } from "@phosphor-icons/react";
import {
  Button,
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
  TooltipProvider,
} from "@replicate/ui";
import type { Model } from "../types";

export default function PriceTooltip({
  model,
}: {
  model: Model;
}) {
  return (
    <TooltipProvider showTimeout={0}>
      <TooltipAnchor
        render={
          <Button
            size="sm"
            variant="clear"
            className="w-full justify-start"
            startIcon={<ClockCounterClockwise size={16} />}
            endIcon={<ArrowSquareOut size={16} />}
            render={
              // biome-ignore lint/a11y/useAnchorContent: <explanation>
              <a
                target="_blank"
                rel="noreferrer"
                href={`/predictions?model=${model.owner}/${model.name}`}
              />
            }
          />
        }
      >
        <span className="flex-1">Predictions</span>
      </TooltipAnchor>
      <Tooltip className="max-w-48 text-r8-xs z-50">
        <TooltipArrow />
        View the last 24 hours of your predictions with this model.
      </Tooltip>
    </TooltipProvider>
  );
}
